module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_1.e94b6143.png";